// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Textarea-module--input-wrapper--2Wx6X","input":"Textarea-module--input--kpam6","error":"Textarea-module--error--3Lar6"};